import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectDestructuringEmpty from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty";
import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

var merge = require('lodash/fp/merge');

import { Organization } from '@heimdall/core-domain';
import { logging } from '@heimdall/core-common';
import { getOrganizationData } from '../accessors';
export function generate(firestore) {
  var logger = logging.instantiateLogger('heimdall:app:organization:resolvers:query');
  var organizationDataRequestor = getOrganizationData(firestore);
  return {
    getOrganizationData: function () {
      var _getOrganizationData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(_, _ref, _ref2) {
        var oid, log, request, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                oid = _ref.oid;

                _objectDestructuringEmpty(_ref2);

                log = logger.extend('getOrganizationData');
                log("Getting Organization Data for OID: ".concat(oid));
                _context.prev = 4;
                _context.next = 7;
                return organizationDataRequestor(oid);

              case 7:
                request = _context.sent;
                data = request.fold(function (err) {
                  return err;
                }, function (org) {
                  return org;
                });
                return _context.abrupt("return", merge(data, {
                  __typename: Organization.Organization.name
                }));

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](4);
                console.log(_context.t0);
                throw _context.t0;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 12]]);
      }));

      function getOrganizationData(_x, _x2, _x3) {
        return _getOrganizationData.apply(this, arguments);
      }

      return getOrganizationData;
    }()
  };
}